import React, { useCallback } from 'react';
import classnames from 'classnames/bind';
import { noop } from 'lodash';
import { ChatIcon } from 'tuui';
import CommonCollapsibleCard from 'components/CommonCollapsibleCard/CommonCollapsibleCard';
import { SectionHeader } from 'modules/campaigns/components';
import { useFormFieldValue } from 'modules/taboola-common-frontend-modules/formData';
import { FormattedMessage } from 'modules/taboola-common-frontend-modules/i18n';
import { chatSender } from '../../consts/chatState';
import { ChatHistory } from './ChatHistory';
import { ChatInput } from './ChatInput';
import styles from './chat.module.scss';

const classNameBuilder = classnames.bind(styles);

export const ChatSection = ({ onSubmit, containerClassName }) => {
    const { value: landingPageId } = useFormFieldValue({ field: 'landingPageId' });
    const { value: chatHistory = [], onChange: onChatHistoryChange } = useFormFieldValue({ field: 'chatHistory' });
    const disabled = !landingPageId;

    const handleMessageSubmit = useCallback(
        async (message, sender) => {
            const newChatHistory = [...chatHistory, { sender, text: message }];
            onChatHistoryChange(newChatHistory);
            await onSubmit();
        },
        [chatHistory, onChatHistoryChange, onSubmit]
    );

    return (
        <CommonCollapsibleCard
            id="chat-section"
            collapsed={false}
            setCollapsed={noop}
            header={
                <SectionHeader
                    headerIcon={<ChatIcon />}
                    headerText={
                        <FormattedMessage id="landing.pages.form.chat.section.title" defaultMessage="Chat with AI" />
                    }
                />
            }
        >
            <div className={classNameBuilder('container', containerClassName)}>
                <ChatHistory
                    disabled={disabled}
                    onSuggestionSubmit={message => handleMessageSubmit(message, chatSender.suggestion)}
                />
                <ChatInput onUserInput={message => handleMessageSubmit(message, chatSender.user)} disabled={disabled} />
            </div>
        </CommonCollapsibleCard>
    );
};
